export const baseURL = 'https://cmc-node-baas.herokuapp.com/';
